import React from 'react'

import NavigationMenuSection from "../../../menu-items/section/section"
import NavigationSection from "../../../../../core/model2/navigation/navigation-section"
import {SettingsItemType} from "../@type"
import MenuSettings_Items from "../settings-menu-items"
import {WEBHOOKS_SETTINGS_URL} from "../../../../../core/model2/webhook/webhook-v2/@const"

type Props = {
    onToggle            : (a: string, b: boolean)=>void
    isManager?          : boolean
    collapseState       : any,
    navigationSection   : NavigationSection
}

export default function MenuSettingsIntegrations(props: Props) {

    const onToggle = (isOpen: boolean) => {
        props.onToggle('integrations', isOpen)
    }

    const items: SettingsItemType[] = [
        {
            name        : "Integrations",
            icon        : "i5-integration",
            url         : 'settings/integrations',
        },
        {
            name        : "API",
            icon        : "i5-api",
            url         : 'settings/api-v2',
        },
        {
            name        : "MCP",
            icon        : "i5-mcp",
            url         : 'settings/mcp',
        },
        {
            name        : "Webhooks",
            icon        : "i5-webhook",
            subItems    : [
                {
                    name        : "Webhooks",
                    icon        : "i5-webhook",
                    url         : WEBHOOKS_SETTINGS_URL,
                    exactUrl    : true,
                },
                {
                    name        : "Logs",
                    icon        : "i5-log",
                    url         : 'settings/webhooks/logs',
                },
            ]
        },
    ]

    return (
        <NavigationMenuSection name         = "Integrations"
                               collapsible  = {true}
                               counter      = {items.length}
                               isOpen       = {!props.collapseState.isCollapsed('integrations')}
                               onToggle     = {onToggle}>

            <MenuSettings_Items items               = {items}
                                navigationSection   = {props.navigationSection}/>

        </NavigationMenuSection>
    )

}
